import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"1300"},model:{value:(_vm.modalProp),callback:function ($$v) {_vm.modalProp=$$v},expression:"modalProp"}},[_c(VCard,[_c(VCardTitle,{staticClass:"white"},[_c(VRow,[_c('div',{staticClass:"col-10",staticStyle:{"font-size":"small"}},[_c('span',{staticClass:"green--text"},[_c('b',[_vm._v(_vm._s(_vm.hospital))])])]),_c('div',{staticClass:"col-2 d-flex justify-end"},[_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){_vm.modalProp = false}}},[_c(VIcon,[_vm._v(_vm._s(_vm.mdiClose))])],1)],1)])],1),_c(VDivider),_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.diagData,"items-per-page":5,"footer-props":{
                'items-per-page-options': [5, 10, 15, -1],
                'items-per-page-text': ''
            }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }